import { __decorate, __extends } from "tslib";
import { Component, Vue } from 'vue-property-decorator';
import AddEditCopyProduct from '../components/addEditCopyProduct.vue';
import AddEditCopyPackaging from '../components/addEditCopyPackaging.vue';

var AddProductPage = function (_super) {
  __extends(AddProductPage, _super);

  function AddProductPage() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.productType = _this.$enum.product.ProductTypeMap.PRODUCT;
    return _this;
  }

  AddProductPage.prototype.handleProductTypeChange = function (value) {
    this.productType = value;
  };

  AddProductPage = __decorate([Component({
    components: {
      AddEditCopyProduct: AddEditCopyProduct,
      AddEditCopyPackaging: AddEditCopyPackaging
    }
  })], AddProductPage);
  return AddProductPage;
}(Vue);

export default AddProductPage;